
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.125","height":"13.125","viewBox":"0 0 13.125 13.125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 151264","d":"M6.563 0A6.547 6.547 0 000 6.562a6.547 6.547 0 006.563 6.562 6.547 6.547 0 006.562-6.562A6.547 6.547 0 006.563 0zm0 12.249A5.683 5.683 0 01.875 6.562 5.683 5.683 0 016.563.875a5.683 5.683 0 015.687 5.687 5.683 5.683 0 01-5.687 5.687zM7 6.37V3.062a.432.432 0 00-.437-.437.432.432 0 00-.437.437v3.5a.439.439 0 00.137.3L8.45 9.05a.439.439 0 00.3.137.439.439 0 00.3-.137.387.387 0 000-.6z","fill":"#0079f2"}})])
          )
        }
      }
    